class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('button[type="reset"]').addEventListener(
      'click',
      this.reset.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');

    // Tab cycle. The theme's trapFocus snapshots its focusable list when the modal
    // opens, but predictive-search results render afterwards, so that list goes stale.
    // Attached once at construction, evaluates open-state inside the handler,
    // recomputes the focusables on every Tab.
    document.addEventListener('keydown', this.onTabKey.bind(this));
  }

  onTabKey(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'TAB') return;
    if (!this.detailsContainer.hasAttribute('open')) return;

    const container = this.querySelector('.search-modal');
    if (!container || !container.contains(document.activeElement)) return;

    const elements = getFocusableElements(container).filter(
      (el) => el.getClientRects().length > 0 && el.tabIndex >= 0
    );
    if (elements.length < 2) return;

    const first = elements[0];
    const last = elements[elements.length - 1];

    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
    else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    const searchInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (searchInput) searchInput.focus();
  }

  close() {
    removeTrapFocus(this.summaryToggle);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    if (event)
    event.preventDefault();
    this.querySelector('input[type="search"]').value = '';
  }
}

customElements.define('search-modal', SearchModal);